<template>
  <div class="main-content">
    <!-- 标题 -->
    <div class="title">{{this.$route.name}}</div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{this.$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索栏 -->
    <div class="handle-box">
      <el-row>
        <el-col :span="8">
          <el-input v-model="searchForm.shopName" :placeholder="$t('shop.shopName')" clearable></el-input>
        </el-col>
        <el-col :span="8">
          <el-input v-model="searchForm.shopAddress" :placeholder="$t('shop.shopAddress')" clearable></el-input>
        </el-col>
        <el-col :span="8">
          <el-select v-model="searchForm.status" :placeholder="$t('shop.shopStatus')" clearable>
            <el-option :label="$t('shop.operating')" :value="1"></el-option>
            <el-option :label="$t('shop.closed')" :value="0"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-button type="primary" @click="search">{{ $t('common.query') }}</el-button>
      <el-button @click="reset">{{ $t('common.reset') }}</el-button>
      <el-button type="success" @click="handleAdd">{{ $t('common.add') }}</el-button>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" header-align="center" align="center" width="80" :label="$t('common.id')"></el-table-column>
        <el-table-column prop="shopName" header-align="center" align="center" :label="$t('shop.shopName')"></el-table-column>
        <el-table-column prop="shopAddress" header-align="center" align="center" :label="$t('shop.shopAddress')"></el-table-column>
        <el-table-column prop="shopPhone" header-align="center" align="center" :label="$t('shop.shopPhone')"></el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('common.image')">
          <template slot-scope="scope">
            <img :src="scope.row.shopImage" width="50" height="50" @click="showImage(scope.row.shopImage)">
          </template>
        </el-table-column>
        <el-table-column prop="businessHours" header-align="center" align="center" :label="$t('shop.businessHours')"></el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('shop.shopStatus')">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? $t('shop.operating') : $t('shop.closed') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" width="200" :label="$t('common.createTime')">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" width="200" :label="$t('common.operation')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('common.edit') }}</el-button>
            <el-button type="text" size="small" @click="handleBindCoaches(scope.row)">{{ $t('shop.bindCoaches') }}</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row.id)">{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;"
      ></el-pagination>
    </div>

    <!-- 添加/修改弹窗 -->
    <el-dialog :title="!dataForm.id ? '新增' : '修改'" :visible.sync="dialogFormVisible" width="50%" @closed="closeDialog">
      <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="100px">
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="dataForm.shopName" placeholder="店铺名称"></el-input>
        </el-form-item>
        <el-form-item label="店铺地址" prop="shopAddress">
          <el-input v-model="dataForm.shopAddress" placeholder="店铺地址"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="shopPhone">
          <el-input v-model="dataForm.shopPhone" placeholder="联系电话"></el-input>
        </el-form-item>
        <el-form-item label="店铺简介" prop="shopDesc">
          <el-input type="textarea" v-model="dataForm.shopDesc" placeholder="店铺简介"></el-input>
        </el-form-item>
        <el-form-item label="店铺图片" prop="shopImage">
          <el-upload
            class="avatar-uploader"
            :action="`${$base}/file/upload`"
            :show-file-list="false"
            :on-success="uploadShopImageSuccess"
            :before-upload="beforeShopImageUpload">
            <img v-if="dataForm.shopImage" :src="dataForm.shopImage" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="营业时间" prop="businessHours">
          <el-input v-model="dataForm.businessHours" placeholder="营业时间，例如：周一至周日 08:00-22:00"></el-input>
        </el-form-item>
        <el-form-item label="店铺状态" prop="status">
          <el-select v-model="dataForm.status" placeholder="店铺状态">
            <el-option label="营业中" :value="1"></el-option>
            <el-option label="已关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 绑定教练弹窗 -->
    <el-dialog title="绑定教练" :visible.sync="dialogCoachVisible" width="50%">
      <el-form :model="coachForm" ref="coachForm" label-width="80px">
        <el-form-item label="店铺">
          <span>{{ coachForm.shopName }}</span>
        </el-form-item>
        <el-form-item label="教练" prop="coachIds">
          <el-select v-model="coachForm.coachIds" multiple placeholder="请选择教练" style="width: 100%">
            <el-option
              v-for="item in coachOptions"
              :key="item.id"
              :label="`${item.jiaolianxingming}(${item.jiaolianbianhao})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCoachVisible = false">取 消</el-button>
        <el-button type="primary" @click="coachFormSubmit()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看大图弹窗 -->
    <el-dialog :visible.sync="dialogImageVisible" width="50%">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        shopName: '',
        shopAddress: '',
        status: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      dialogFormVisible: false,
      dialogCoachVisible: false,
      dialogImageVisible: false,
      dialogImageUrl: '',
      dataForm: {
        id: 0,
        shopName: '',
        shopAddress: '',
        shopPhone: '',
        shopDesc: '',
        shopImage: '',
        businessHours: '',
        status: 1,
      },
      coachForm: {
        shopId: 0,
        shopName: '',
        coachIds: []
      },
      coachOptions: [],
      dataFormRules: {
        shopName: [
          { required: true, message: '店铺名称不能为空', trigger: 'blur' }
        ],
        shopAddress: [
          { required: true, message: '店铺地址不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '店铺状态不能为空', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        shopName: this.searchForm.shopName,
        shopAddress: this.searchForm.shopAddress,
        status: this.searchForm.status
      }
      this.$http({
        url: '/shop/page',
        method: 'get',
        params: params
      }).then(({data}) => {
        console.log("获取店铺列表数据",data);
        
        if (data && data.code === 0) {
          this.dataList = data.data.list
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 搜索
    search() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 重置
    reset() {
      this.searchForm = {
        shopName: '',
        shopAddress: '',
        status: ''
      }
      this.getDataList()
    },
    // 新增
    handleAdd() {
      this.dialogFormVisible = true
      this.dataForm = {
        id: 0,
        shopName: '',
        shopAddress: '',
        shopPhone: '',
        shopDesc: '',
        shopImage: '',
        businessHours: '',
        status: 1,
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    // 修改
    handleEdit(row) {
      this.dialogFormVisible = true
      this.dataForm = JSON.parse(JSON.stringify(row))
    },
    // 删除
    handleDelete(id) {
      this.$confirm(`确定删除?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/shop/delete',
          method: 'post',
          data: [id]
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/shop/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: this.dataForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogFormVisible = false
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    // 上传图片前校验
    beforeShopImageUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    // 上传图片成功回调
    uploadShopImageSuccess(res, file) {
      if (res.code === 0) {
        this.dataForm.shopImage = res.data
      } else {
        this.$message.error('上传失败，请重试')
      }
    },
    // 绑定教练
    handleBindCoaches(row) {
      this.dialogCoachVisible = true
      this.coachForm = {
        shopId: row.id,
        shopName: row.shopName,
        coachIds: []
      }
      
      // 获取店铺详情（包含已绑定的教练）
      this.$http({
        url: `/shop/info/${row.id}`,
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 0) {
          if (data.data.coachIds) {
            this.coachForm.coachIds = data.data.coachIds
          }
        }
      })
      
      // 获取所有教练列表
      this.$http({
        url: '/jiaolian/list',
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 0) {
          console.log("jiaolian",data);
          
          this.coachOptions = data.data.list
        }
      })
    },
    // 提交教练绑定表单
    coachFormSubmit() {
      if (!this.coachForm.coachIds || this.coachForm.coachIds.length === 0) {
        this.$message.warning('请至少选择一名教练');
        return;
      }
      
      this.$http({
        url: `/shop/bind/${this.coachForm.shopId}`,
        method: 'post',
        data: this.coachForm.coachIds
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.$message({
            message: '绑定成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.dialogCoachVisible = false
              this.getDataList()
            }
          })
        } else {
          this.$message.error(data.msg || '操作失败')
        }
      }).catch(error => {
        console.error('绑定教练失败:', error);
        this.$message.error('绑定失败，请检查数据格式或联系管理员');
      })
    },
    // 显示大图
    showImage(url) {
      this.dialogImageUrl = url
      this.dialogImageVisible = true
    },
    // 添加关闭弹窗处理方法
    closeDialog() {
      this.$refs['dataForm'].resetFields()
      this.dataForm = {
        id: 0,
        shopName: '',
        shopAddress: '',
        shopPhone: '',
        shopDesc: '',
        shopImage: '',
        businessHours: '',
        status: 1,
      }
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}
.handle-box {
  margin-bottom: 20px;
}
.el-row {
  margin-bottom: 10px;
}
.el-col {
  padding-right: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style> 